import type { Memo } from "@/lib/types";

export const MEMO_TITLE_MAX = 120;

// 行頭の Markdown 記号(見出し/箇条書き/チェックボックス/引用/番号リスト)を落とす
const MD_LINE_PREFIX = /^\s*(?:#{1,6}\s+|[-*+]\s+(?:\[[ xX]\]\s*)?|>\s*|\d+\.\s+)/;

/** 本文1行目からタイトルを導出。空なら「無題」 */
export function deriveMemoTitle(content: string): string {
  for (const raw of content.split("\n")) {
    const line = raw.replace(MD_LINE_PREFIX, "").trim();
    if (line) return line.slice(0, MEMO_TITLE_MAX);
  }
  return "無題";
}

export type MemoNotebookFilter = "all" | "none" | string;

export function filterMemos(
  memos: Memo[],
  filter: { notebookId: MemoNotebookFilter; query: string },
): Memo[] {
  const q = filter.query.trim().toLowerCase();
  return memos.filter((m) => {
    if (filter.notebookId === "none" && m.notebookId) return false;
    if (filter.notebookId !== "all" && filter.notebookId !== "none" && m.notebookId !== filter.notebookId)
      return false;
    if (q && !`${m.title}\n${m.content}`.toLowerCase().includes(q)) return false;
    return true;
  });
}

/** updatedAt 降順(新しい順)。元配列は変更しない */
export function sortMemos(memos: Memo[]): Memo[] {
  return [...memos].sort((a, b) => b.updatedAt - a.updatedAt);
}
